(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
  const slideshows = document.querySelectorAll('slideshow-component');
  if (!slideshows.length) return;

  const pageLoaded = new Promise((resolve) => {
    if (document.readyState === 'complete') resolve();
    else window.addEventListener('load', resolve, { once: true });
  });

  const posterReady = async (poster) => {
    if (!poster) return;
    if (!poster.complete) {
      await new Promise((resolve) => {
        poster.addEventListener('load', resolve, { once: true });
        poster.addEventListener('error', resolve, { once: true });
        poster.loading = 'eager';
      });
    }
    if (poster.naturalWidth && poster.decode) await poster.decode().catch(() => {});
  };

  // Decode the LCP image and allow a paint before any slide can request video.
  const heroPainted = posterReady(
    document.querySelector('.slide__video-poster[fetchpriority="high"], .slide__image[fetchpriority="high"]')
  ).then(() => new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve))));

  slideshows.forEach((slideshow) => {
    let isInViewport = false;
    const pending = new WeakSet();

    const isActive = (slide, index) =>
      slide.getAttribute('aria-hidden') === 'false' ||
      (!slide.hasAttribute('aria-hidden') && !slide.hasAttribute('hidden') && index === 0);

    const startPlayback = async (slide, video, index) => {
      if (pending.has(video)) return;
      pending.add(video);
      try {
        await Promise.all([heroPainted, pageLoaded]);
        if (!isInViewport || !isActive(slide, index)) return;

        const poster = slide.querySelector('.slide__video-poster');
        await posterReady(poster);
        if (!isInViewport || !isActive(slide, index)) return;

        const sources = video.querySelector('[data-deferred-slide-sources]');
        if (sources) {
          // Reuse the browser-selected image; never download Shopify's default small poster.
          if (poster?.naturalWidth) video.poster = poster.currentSrc || poster.src;
          video.append(sources.content.cloneNode(true));
          sources.remove();
          video.addEventListener('playing', () => video.setAttribute('data-video-playing', ''), { once: true });
          video.load();
        }
        await video.play().catch(() => {});
      } finally {
        pending.delete(video);
      }
    };

    const syncPlayback = () => {
      const slides = slideshow.querySelectorAll('slideshow-slide');
      slides.forEach((slide, index) => {
        const video = slide.querySelector('[data-deferred-slide-video]');
        if (!video) return;

        if (isInViewport && isActive(slide, index)) {
          startPlayback(slide, video, index).catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    const slideObserver = new MutationObserver(syncPlayback);
    slideObserver.observe(slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'hidden', 'reveal'],
    });

    if ('IntersectionObserver' in window) {
      const viewportObserver = new IntersectionObserver(
        ([entry]) => {
          isInViewport = entry.isIntersecting;
          syncPlayback();
        },
        { rootMargin: '100px' }
      );
      viewportObserver.observe(slideshow);
    } else {
      isInViewport = true;
    }

    syncPlayback();
  });
})();
